export class VehicleConstants {
  public static AVERAGE_SPEED_KMPH = 20

  public static AVERAGE_SPEED_METERS_PER_SECOND = VehicleConstants.AVERAGE_SPEED_KMPH / 3.6
}
